import * as React from "react";
const HomeCareAndIndustrialCleaningSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="rgba(238, 65, 55, 1)"
      d="M10 5V4a.965.965 0 0 1-.712-.288A.972.972 0 0 1 9 3c0-.283.095-.52.288-.712A.97.97 0 0 1 10 2h5c.283 0 .521.096.713.288.192.192.288.43.287.712v.775a.787.787 0 0 1-.025.213c-.017.059-.042.13-.075.212L15 6h-3V5l-1.875 1.875c-.017.017-.15.058-.4.125a.435.435 0 0 1-.387-.213.399.399 0 0 1-.013-.437L10 5Zm0 17c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 0 1 8 20v-4.925c0-.167.017-.329.05-.487.033-.158.092-.312.175-.463l3.2-6.05a2.1 2.1 0 0 1 .738-.788A1.917 1.917 0 0 1 13.2 7H15c.283 0 .521.096.713.288.192.192.288.43.287.712v12c0 .55-.196 1.021-.587 1.413A1.92 1.92 0 0 1 14 22h-4Zm0-2h4V9h-.8L10 15.1V20Z"
    />
  </svg>
);
export default HomeCareAndIndustrialCleaningSVG;
